import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Layout } from 'antd'
import { MenuUnfoldOutlined, MenuFoldOutlined, SmileOutlined } from '@ant-design/icons'
import Top from '../Top'
import Menu from '../Menu'
import Logo from '../Logo'
import cls from './index.module.scss'
import blurBg from '@/images/blur-bg.png'
import MyIcon from 'components/MyIcon'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';

const { Sider, Header, Content } = Layout

const MenuWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #f0f0f0;
`
const HeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 100%;
`

const TestComp = () => {
  console.log('testComp render')
  return <div>测试组件</div>
}

function LayoutHorizontal({ children }) {
  const { t } = useTranslation()
  const [collapsed, setCollapsed] = useState(false)
  const [showAppName, setShowAppName] = useState(true)
  const { users } = useSelector(state => state.user)
  const toogleCollapsed = () => {
    if (showAppName) {
      setShowAppName(!showAppName)
    } else {
      setTimeout(() => {
        setShowAppName(!showAppName)
      }, 100)
    }
    setCollapsed(!collapsed)
  }

  console.log('LayoutHorizontal render...')
  return (
    <Layout className={cls.layout}>
      <Sider
        className={cls.sider}
        // width={180}
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <div className={cls.LogoWrapper}>
          <Logo collapsed={collapsed} />
          {
            showAppName && (
              <span>
                {t('appName')}
              </span>
            )
          }
        </div>
        <MenuWrapper>
          <Menu collapsed={collapsed} />
          {/* {
            users?.app_key != 'shopify' ?
              <a className={cls.urlMenu} href="https://fuwu.taobao.com/ser/detail.htm?service_code=ts-10971"
                target="_blank" style={{ marginLeft: collapsed ? 33 : 24 }}>
                <MyIcon type="icon-zhongchapingchuli" style={{ marginRight: 9, fontSize: 16 }} />
                {collapsed ? '' : <span>中差评处理</span>}
              </a> : null
          } */}
        </MenuWrapper>
      </Sider>
      <Layout className={cls.main}>
        <Header className={cls.header}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: cls.trigger,
              onClick: toogleCollapsed
            }
          )}
          <Top />
        </Header>
        <Content className="site-layout" style={{ flex: 1 }}>
          <div className="site-layout-background" style={{ height: '100%' }}>
            {/* <img className='blur-bg-img' src={blurBg} style={{ position: 'absolute' }} /> */}
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

LayoutHorizontal.propTypes = {
  children: PropTypes.shape().isRequired
}

export default LayoutHorizontal
